export default {
  common: {
    '登录/注册': 'Login/Register',
    '首页': 'HOME',
    '新闻': 'NEWS',
    '方法': 'METHOD',
    '数据': 'DATA',
    '团队': 'TEAM',
    '关于': 'ABOUT',
    '联系': 'Contact',
    '免责声明': 'Disclaimers',
    '联系我们': 'Contact Us',
    '注册协议': 'Registration Agreement',
    '隐私政策': 'Privacy Policy',
    '版权所有©2023 保留所有权利': 'All rights reserved © 2023. All rights reserved',
    '客服电话': 'Customer service',
    '工作时间': 'Working hours',
    '官方邮箱': 'Official email',
    '扫码添加客服微信': 'Customer service WeChat',
    '扫码添加客服QQ': 'Customer service QQ',
    '提示': 'Tip',
    '请先登录在进行数据下载': 'Please log in first for data download',
    '取消': 'Cancel',
    '确认': 'Ok',
    
    '登录': 'Login',
    '注册': 'Register',
    '退出': 'LogOut',
    '请勿重复点击': 'Do not click repeatedly',
    '搜索': 'Search',
    '重置': 'Resetting',
    '确认退出当前账号？': 'Are you sure to exit the current account?',
    '欢迎来到intelligent carbon中国上市公司碳数据库': 'Welcome to Intelligent Carbon carbon database of listed companies in China',
    '忘记密码': 'Forgot password',
    '账号登录': 'Account login',
    '注册账号': 'Register an account',
    '请阅读并同意': 'Please read and agree',
    '和': 'and',
    '请输入您的邮箱地址': 'Please enter your email address',
    '请输入您的登录密码': 'Please enter your login password',
    '验证码登录': 'Verification code login',
    '忘记密码？': 'Forgot password?',
    '手机号登录': 'Login with phone number',
    '请输入验证码': 'Please enter the verification code',
    '获取验证码': 'Get verification',
    '验证码已发送，请注意查收': 'The verification code has been sent, please check it carefully',
    '密码登录': 'Password login',
    '重置成功，请使用新密码登录': 'Reset successful, please log in with a new password',
    '请输入您的手机号': 'Please enter your phone number',
    '邮箱地址格式不正确': 'Incorrect email address format',
    '手机号格式不正确': 'Incorrect phone number format',
    '请输入6-12位包含字母和数字的密码': 'Please enter a password consisting of 6-12 letters and numbers',
    '邮箱登录': 'Email login',
    '请输入您的密码': 'Please enter your password',
    '请再次输入您的密码': 'Please enter your password again',
    '请输入您的姓名': 'Please enter your name',
    '请输入您的联系方式': 'Please enter your contact information',
    '请输入您的单位名称': 'Please enter your company name',
    '请输入您的新密码': 'Please enter your new password',
    '请再次输入您的新密码': 'Please enter your new password again',
    '两次密码不一致': 'The two passwords do not match',
    '确定': 'Ok',
    '返回登录': 'Return to login',
    '手机号注册': 'Mobile number registration',
    '邮箱注册': 'Email registration',
    '我已阅读并同意': 'I have read and agree',
    '您的认证审核已提交成功': 'Your certification review has been successfully submitted',
    '您的申请已提交，1-3个工作日为您反馈审核结果': 'Your application has been submitted, and we will provide you with feedback on the review results within 1-3 working days',
    '返回首页': 'Home',
    
    '查看详情': 'Details',
    '新闻详情': 'News Details',
    '团队详情': 'Team Details',
    '数据下载': 'Data Download',
    '下载失败，请重试': 'Download failed, please try again',
    '按行业查询': 'Query by Industry',
    '按企业查询': 'Query by Enterprise',
    '按年份查询': 'Query by Year',
    '请选择': 'Please select',
    '展开筛选': 'Expand Filter',
    '收起筛选': 'Collapse Filter',
    '选择的企业：': 'Selected enterprise: ',
    '总': 'Assemble',
    '未知': 'Unknown',
    '二氧化碳': 'Carbon Dioxide ',
    '年排放量（吨二氧化碳）': 'emissions (tons of CO2)',
    '企业每年总二氧化碳排放量': 'Carbon Dioxide emissions of enterprise',
    '行业每年总二氧化碳排放量': 'Carbon Dioxide emissions of industry',
    '年': 'Year',
    '总二氧化碳排放量': 'Total carbon dioxide emissions',
    '吨': 'Ton',

    
    '暂无数据': 'None',
    '操作成功': 'Success',
    '充值': 'Recharge',
    '积分': 'Integral',
    '设置': 'Set',
    '已订阅': 'Subscribed',
    '暂未订阅': 'Not Subscribed',
    '立即订阅': 'Subscribe Now',
    '立即续费': 'Renew Immediately',
    '积分充值': 'Point Recharge',
    '积分余额': 'Points Balance',
    '自定义充值': 'Custom Recharge',
    '支付': 'Payment',
    '微信': 'WeChat',
    '支付宝': 'Alipay',
    '立即充值': 'Recharge Now',
    '请输入': 'Please Enter',
    '订阅': 'Subscribe',
    '月': 'Month',
    '确认协议并支付': 'Confirm the agreement and make payment',
    '本次下载需消耗': 'This download requires consumption',
    '立即下载': 'Download Now',
    '个人资料': 'User Info',
    '意见反馈': 'Feedback',
    '修改密码': 'Change password',
    '修改绑定手机号': 'Modify binding phone',
    '修改绑定邮箱': 'Modify binding email',
    '头像': 'Head sculpture',
    '手机号': 'Phone',
    '昵称': 'Nickname',
    '性别': 'Sex',
    '保密': 'Secrecy',
    '男': 'Boy',
    '女': 'Girl',
    '保存': 'Save',
    '完成': 'Complete',
    '旧密码': 'Old password',
    '新密码': 'New password',
    '6~12位英文+数字的密码': '6-12 digit password with English and numbers',
    '确认新密码': 'Confirm new password',
    '验证码': 'Code',
    '新手机号': 'New phone',
    '新手机号验证码': 'New phone verification code',
    '获取验证码': 'Obtain verification code',
    '我们要对您绑定的手机号进行验证': 'We need to verify the phone number you bound',
    '我们要对您绑定的邮箱进行验证': 'We need to verify the email you bound',
    '新邮箱': 'New email',
    '新邮箱验证码': 'New email verification code',
    '邮箱': 'Email',
    '反馈类型': 'Feedback Type',
    '产品建议': 'Recommendation',
    '功能故障': 'Fault',
    '其他问题': 'Other',
    '问题描述': 'Problem Description',
    '问题描述的越详细，有助于我们更快的解决问题~': 'The more detailed the problem description, the faster it will help us solve the problem~',
    '请上传应用截图，': 'Please upload a screenshot of the application,',
    '最多上传6张': 'Upload up to 6 photos',
    '提交反馈': 'Submit Feedback',
    '反馈记录': 'Feedback Record',
    '反馈类型：': 'Feedback type:',
    '反馈时间：': 'Feedback time:',
    '平台回复：': 'Platform response:',
    '请上传': 'Please upload',
    '反馈图片': 'Feedback image',
    '每': 'Every',
    '季': 'Season',
    '半年': 'Half a year',
    '全部下载': 'Download All',
    '确认协议并支付': 'Confirm the agreement and make payment',
    '订阅前请阅读': 'Please read before subscribing',
    '订阅协议': 'Subscription agreement',
    '特权对比': 'Privilege comparison',
    '普通用户': 'Ordinary users',
    '订阅特权': 'Subscription privileges',
    '每条数据下载都需要付费': 'Each data download requires a fee',
    '订阅时间内可下载任何数据': 'Any data can be downloaded during subscription time',
    '到期': ' End',
    '文件大小超出10MB限制, 请压缩或降低文件质量': 'The file size exceeds the 10MB limit. Please compress or reduce the file quality'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js